<template>
  <v-card>
    <v-container class="py-0">
      <v-row>
        <v-col cols="auto" class="pr-0">
          <user-avatar :size="32" :user="user"></user-avatar>
        </v-col>
        <v-col cols="auto" class="my-auto">
          <div class="secondary--text">
            {{ user.fullName }}
          </div>
        </v-col>
      </v-row>
      <v-row class="subtitle-1">
        <v-col cols="12">
          <template v-if="allowCompletion">
            {{ user.firstName }} has {{ actionItems.length }} action items from
            previous meetings.
          </template>
          <template v-else>
            {{ user.firstName }} has {{ actionItems.length }} action items that
            were created from this meeting.
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            small
            text
            color="lighttext"
            v-if="actionItems.length > 0"
            class="pa-0"
            @click="show_action_items = !show_action_items"
          >
            {{ actionItems.length }} Action Items
            <v-icon small>{{
              !show_action_items ? "expand_more" : "expand_less"
            }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <template v-if="show_action_items">
      <template v-for="actionItem in sorted_action_items">
        <action-item-line-item
          class="mx-0"
          :key="actionItem.id"
          :actionItem="actionItem"
          v-on:edit="editActionItem(actionItem)"
          :allowCompletion="allowCompletion"
          :disabled="isComplete"
          v-on:redraw="$emit('redraw')"
          small-text
        ></action-item-line-item>
      </template>
    </template>
    <edit-action-item-dialog ref="editActionItem"></edit-action-item-dialog>
  </v-card>
</template>

<script>
import ActionItemLineItem from "@/components/checkin/ActionItemLineItem";
import EditActionItemDialog from "@/components/checkin/EditActionItemDialog";
import { mapGetters } from "vuex";
export default {
  components: {
    EditActionItemDialog,
    ActionItemLineItem
  },
  name: "ActionItemsCard",
  props: {
    actionItems: { type: Array },
    allowCompletion: { type: Boolean },
    user: { type: Object }
  },
  data: () => ({ show_action_items: false }),
  computed: {
    isComplete() {
      return this.checkin.completeDate != null;
    },
    sorted_action_items() {
      return this._.orderBy(
        this.actionItems,
        ["completeDate", "dueDate"],
        ["desc", "asc"]
      );
    },
    ...mapGetters({ checkin: "checkin/checkin" })
  },
  methods: {
    edit() {
      this.$refs.editTalkingPoint.showDialog(this.talkingPoint);
    },
    editActionItem(actionItem) {
      this.$refs.editActionItem.showDialog(actionItem);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  border-top: solid 8px var(--v-info-base);
}
</style>
